const part0 = SECRET.PART_0;

const xor = (text: string) => {
  return Array.from(text)
    .map((character, index) => {
      return String.fromCharCode(
        character.charCodeAt(0) ^ (index % text.length),
      );
    })
    .join("");
};

const part2 = SECRET.PART_2;

const getSecretKey = () => {
  return [
    xor(restoreKey(part0).join("")),
    xor(restoreKey(part1).join("")),
    xor(restoreKey(part2).join("")),
    xor(restoreKey(part3).join("")),
    xor(restoreKey(part4).join("")),
    xor(restoreKey(part5).join("")),
    xor(restoreKey(part6).join("")),
    xor(restoreKey(part7).join("")),
  ].join("");
};

const part1 = SECRET.PART_1;

const restoreKey = (bytes: number[]) => {
  return bytes.map((byte) => String.fromCharCode(byte));
};

const part3 = SECRET.PART_3;

const getClientId = () => {
  return window.localStorage.getItem("clie" + "ntId") ?? createClientId();
};

const part4 = SECRET.PART_4;

const createClientId = () => {
  const array = new Uint8Array(16);

  crypto.getRandomValues(array);

  const clientId = Array.from(array)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  window.localStorage.setItem("clie" + "ntId", clientId);

  return clientId;
};

const part5 = SECRET.PART_5;

const getHmacSignature = async (message: string, key: string) => {
  // Convert message and key to ArrayBuffer
  const encoder = new TextEncoder();
  const messageBuffer = encoder.encode(message);
  const keyBuffer = encoder.encode(key);

  // Import the key
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBuffer,
    { name: "HM" + "AC", hash: "SH" + "A-2" + "56" },
    false,
    ["sign"],
  );

  // Sign the message
  const signature = await crypto.subtle.sign(
    "HM" + "AC",
    cryptoKey,
    messageBuffer,
  );

  // Convert the signature to hex string
  return Array.from(new Uint8Array(signature))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};

const part6 = SECRET.PART_6;

export const getToken = async () => {
  const timestamp =
    Math.floor(Date.now() / 1000) - (window.serverTimeDelta ?? 0);

  const clientId = getClientId();

  const secret = getSecretKey();

  const nonce = Array.from(crypto.getRandomValues(new Uint8Array(16)))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");

  const payload = {
    timestamp,
    clientId,
    nonce,
  };

  const signature = await (async () => {
    try {
      return await getHmacSignature(JSON.stringify(payload), secret);
    } catch (error) {
      return "".padStart(64, "0");
    }
  })();

  return {
    payload,
    signature,
  };
};

const part7 = SECRET.PART_7;
